export {};

$(init);

function init() {
    $('.field-nested').each(fieldNested);
}

function fieldNested(blockIndex, Block) {
    const $block = $(Block);
    const $checkbox = $block.find('.checkbox__input');

    $checkbox.on('change', function() {
        const $currentCheckbox = $(this);
        const $currentWrapper = $currentCheckbox.closest('.field-nested__item');
        const $childCheckbox = $currentWrapper.find('.checkbox__input');
        const $parentCheckbox = $currentWrapper
            .closest('.field-nested')
            .prev('.checkbox')
            .find('.checkbox__input');
        const $parentChildCheckbox = $currentWrapper.closest('.field-nested').find('.checkbox__input');

        const getCheckedParentCheckbox = () => {
            let parentChecked = false;

            $.each($parentChildCheckbox, (index, element) => {
                if ($(element).prop('checked') === true) {
                    parentChecked = true;
                }
            });

            return parentChecked;
        };

        $childCheckbox.prop('checked', $currentCheckbox.prop('checked'));

        $parentCheckbox.prop('checked', getCheckedParentCheckbox);
    });
}



// WEBPACK FOOTER //
// ./js/main/module/field-nested.js